<template>
  <div class="home div-100">
    <Banner :height="521" v-bind:path="'banner.png'" />
    <v-container>
      <v-card flat color="transparent">
        <v-card-subtitle>
          <h1 class="event-subtitle" v-html="$t('page.pause.text')"></h1>
          <a class="event-date" :href="`mailto:${$t('page.pause.help')}`">{{
            $t("page.pause.help")
          }}</a>
        </v-card-subtitle>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Banner from "_shared/components/Banner";

export default {
  name: "Home",
  components: { Banner },
  methods: {
    async enter() {
      this.$router.push({ name: "WaitingRoom" });
    },
    register() {
      this.$account.register();
    },
    login() {
      this.$account.login();
    },
  },  
};
</script>

<style lang="scss" scoped>
.event-title {
  font-family: "Head";
  font-size: 36px;
  line-height: 1;
  padding-bottom: 40px;
}
.event-subtitle {
  font-family: "Bold";
  font-size: 28px;
  padding-bottom: 16px;
  line-height: 2rem;
}
.event-date {
  font-family: "Bold";
  font-size: 18px;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .event-title {
    font-size: 36px;
  }
  .event-subtitle {
    font-size: 18px;
    line-height: initial;
  }
  .event-date {
    font-size: initial;
  }
}
</style>
